import { createAsyncThunk } from "@reduxjs/toolkit";
import { getValuationEditData } from "../../Api/ValuationEditService";
import { mapValuationData } from "../Types/ValuationEdit/ValuationEditInterface";

//  valuation edit details list
export const getValuationEditDataByFolder = createAsyncThunk('getValuationEditDataByFolder', async (id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getValuationEditData(id);
    if (response.status) {
      return mapValuationData(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});
